import React from "react";

import Icon from "assets/icons";
import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";
import TicketStatus from "shared/enums/TicketStatus";
import { PurchaseConfirmationPropTypes } from "../../types";
import { ConfirmationPageEntityType, InventoryPurchaseTypes } from "../../../enum";

function FooterActions(props: PurchaseConfirmationPropTypes) {
  const copies = useCopies();

  return (
    <div className="printHide purchaseConfirm_btnWrapper">
      {props.entityType === ConfirmationPageEntityType.GET_TICKLET &&
      (props.approvalPending || props.isInvoicePaymentPending) ? (
        <Button
          label={copies.get(props.approvalPending ? "go.to.dashboard" : "close")}
          onClick={props.closeHandler}
          icon={props.approvalPending && <Icon.DashboardThick />}
        />
      ) : // checking `!approvalPending` for ticket upgrade offline payment approval pending case
      props.ticketStatus === TicketStatus.COMPLETED && props.myExperienceLoginUrl && !props.approvalPending ? (
        <NavigateForLoginOrRefresh
          buttonCopy={copies.get("go.to.new.dashboard.label")}
          loginUrl={props.myExperienceLoginUrl}
        />
      ) : props.shouldReloadAfterMeetingPurchase ? (
        <NavigateForLoginOrRefresh buttonCopy={copies.get("buy.meeting.dashboard.reload.button")} />
      ) : (
        // checking `approvalPending` for ticket upgrade offline payment approval pending case
        (InventoryPurchaseTypes.includes(props.entityType) ||
          (props.entityType === ConfirmationPageEntityType.TICKET_CHANGE && props.approvalPending)) && (
          <Button label={copies.get("close")} onClick={props.closeHandler} />
        )
      )}
    </div>
  );
}

export default FooterActions;

function NavigateForLoginOrRefresh(props: { buttonCopy: string; loginUrl?: string }) {
  const autoLoginOrRefreshHandler = React.useCallback(() => {
    // TODO: TW: check why `registrationParticipant/findRegistrationParticipantProgramDetails` is getting called with old token during auto logging-in; provided following workaround for a while
    // clear existing user session before navigating to loginUrl
    props.loginUrl && localStorage.clear();
    window.location.href = props.loginUrl || "";
  }, [props.loginUrl]);

  return <Button onClick={autoLoginOrRefreshHandler} label={props.buttonCopy} icon={<Icon.DashboardThick />} />;
}
